var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pSelectedHost)?_c('div',{staticClass:"d-flex align-center host-status-component"},[_c('v-chip',{staticClass:"host-status-chip",class:_vm.chipColor},[_c('span',{staticClass:"host-status-name"},[_vm._v(_vm._s(_vm.pSelectedHost.getHostDisplayStatus()))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }